<rav-modal [modalId]="modalId" [modalTitle]="isCreateFolders ? 'Create New Folder' : 'Select Folder'">
  {{ isCreateFolders ? 'Choose the location of the new folder.' : 'Select a destination folder.' }}
  {{ foldersToDisable?.length > 0 ? ' Folders cannot be moved to the Inbox or within themselves.' : '' }}
  <div class="folder-select">
    <div class="padding-top-1">
      <rav-folder-menu
        *ngIf="modalOpened"
        [isFolderSelect]="true"
        [addInboxNode]="addInboxNode"
        [foldersToDisable]="foldersToDisable"
        (folderSelected)="folderSelected($event)"
      ></rav-folder-menu>
    </div>
  </div>
  <div class="flex-container align-right padding-top-1 controls">
    <button *ngIf="!isCreateFolders" (click)="closeModal()" class="button hollow">
      Cancel
    </button>
    <button (click)="select()" class="button margin-left-1" data-cy="select-folder">
      Select
    </button>
  </div>
</rav-modal>

<rav-create-folder
  [modalId]="createFoldersModalId"
  [parentId]="selectedFolder?.id"
  [launchNewFolder]="isCreateFolders"
></rav-create-folder>
